import axios from 'axios'
const CODES = {
  SUCCESS: 0
}
const baseUrl = process.env.NODE_ENV === 'production' ? '/zpert/sgyp' : '/'
// const baseUrl = '/'
let sgyToken = null
let globalId = null
let source = null
let version = null
let querys = ''
try {
  querys = (location.hash || '').split('?')[1].split('&')
  for (var i = 0; i < querys.length; i++) {
    const queryItem = querys[i].split('=')
    if (queryItem[0] === 'sgy-token') {
      sgyToken = queryItem[1]
    } else if (queryItem[0] === 'globalId') {
      globalId = queryItem[1]
    } else if (queryItem[0] === 'source') {
      source = queryItem[1]
    } else if (queryItem[0] === 'version') {
      version = queryItem[1]
    }
  }
} catch (e) {
  console.log(e)
}

const http = axios.create({
  baseURL: baseUrl
})
http.interceptors.request.use(function (config) {
  config.headers.Authorization = sgyToken
  return config
}, function (error) {
  return Promise.reject(error)
})
export default {
  async getUserInfo () {
    try {
      const res = await http({
        method: 'GET',
        url: `/_user/userinfo?sgy-token=${sgyToken}&globalId=${globalId}`
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          data: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  async getCompanyList (name) {
    try {
      const res = await http({
        method: 'GET',
        url: `/_user/enterprise/fuzzy/${decodeURIComponent(name)}?sgy-token=${sgyToken}`
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          data: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  async getCompanyInfo (name) {
    try {
      const res = await http({
        method: 'GET',
        url: `/_user/enterprise/precise/${decodeURIComponent(name)}?sgy-token=${sgyToken}`
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          data: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  async getProjectList (name) {
    try {
      const res = await http({
        method: 'GET',
        url: `/_user/zj/search?keyword=${decodeURIComponent(name)}&sgy-token=${sgyToken}`
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          data: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  async getProjectInfo (key) {
    try {
      const res = await http({
        method: 'GET',
        url: `/_user/zj?id=${key}&sgy-token=${sgyToken}`
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          data: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  async getAdministrativeAreas (query) {
    try {
      const res = await http({
        method: 'GET',
        url: `/_user/area?pcode=${query}&sgy-token=${sgyToken}`
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          areas: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  async completeUserInfo (data) {
    try {
      data.source = data.source !== null ? data.source : source
      const res = await http({
        method: 'POST',
        url: `_user/userinfo?sgy-token=${sgyToken}`,
        data
      })
      // if (res.data.code === CODES.SUCCESS) {
      //   return {
      //     status: true,
      //     msg: '成功提交信息'
      //   }
      // }
      return res.data
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },

  async getPosition () {
    try {
      const res = await http({
        method: 'GET',
        url: `/_user/dict/position/${source}?sgy-token=${sgyToken}`
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          data: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  async receive (data) {
    try {
      const res = await http({
        method: 'POST',
        url: `https://tj.glodon.com/receive`,
        data
      })
      return res
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  async getAuth () {
    try {
      const res = await http({
        method: 'GET',
        url: `/_user/auth/get_auth_method?source=${source}&sgy-token=${sgyToken}`
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          data: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      let status = JSON.parse(JSON.stringify(err)).status
      return { status: false, msg: status == 401 ? 'token 过期请重新登录！' : '网络错误' }
    }
  },
  async authorization() {
    try {
      const res = await http({
        method: 'POST',
        url: `/_user/free?source=${source}&sgy-token=${sgyToken}`
        // url: `/_user/free`,
        // data: {
        //   source,
        //   sgyToken,
        // }
      })
      if (res.data.code === CODES.SUCCESS) {
        return {
          status: true,
          msg: '成功获取信息',
          data: res.data.data
        }
      }
      return {
        status: false,
        msg: res.data.msg
      }
    } catch (err) {
      return { status: false, msg: '网络错误' }
    }
  },
  source,
  sgyToken,
  globalId,
  version
}
